import * as React from "react";
import { SVGProps } from "react";

const PaxGold = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 71 67" {...props}>
    <path
      fill="#efe812"
      d="M20 8.84c1.37-1.56 2.63-2.88 3.83-4-20.26-.65-14.36 14-21 28.87-7.6 17.14.9 23.67 13.56 25.71a27.56 27.56 0 0 1-4.28-7C3.94 42.09 7.25 23.26 20 8.84"
    />
    <path
      fill="#ede70a"
      d="M68.75 27.1a57.87 57.87 0 0 1-10.23 17.13A49.09 49.09 0 0 1 46.09 55a33.56 33.56 0 0 1-18.34 5.21 72.2 72.2 0 0 1-11.32-.79A23.14 23.14 0 0 0 24 65.35c18.32 8.86 19.47-7.59 38.85-15.94 10.88-4.69 10.92-13.85 5.89-22.31M46.09 10a24.07 24.07 0 0 1 7.56 2.68 42.17 42.17 0 0 1 15.1 14.42c3.3-9.3 1.76-16.6-5.45-17.92-7.94-1.45-14.14-1.92-20.1-6.08C35.86-2 29.42-.34 23.84 4.85l1.21.05c7.74.46 15.14 2 21 5.08"
    />
    <path
      fill="#dec21c"
      d="M20 8.84C7.25 23.26 3.94 42.09 12.15 52.42a31.36 31.36 0 0 1 1.77-28C20.83 12.9 34.7 7.9 46.09 10c-5.9-3.12-13.3-4.62-21-5.08l-1.21-.06C22.64 6 21.38 7.28 20 8.84"
    />
    <path
      fill="#e5cb22"
      d="M53.65 12.66A24.07 24.07 0 0 0 46.09 10C53.85 14.08 59 21 59 31.94A27.53 27.53 0 0 1 46.09 55a48.89 48.89 0 0 0 12.43-10.77A57.87 57.87 0 0 0 68.75 27.1a42.17 42.17 0 0 0-15.1-14.44"
    />
    <path
      fill="#cca727"
      d="M46.09 10C34.7 7.9 20.83 12.9 13.92 24.37a31.33 31.33 0 0 0-1.77 28.05 27.28 27.28 0 0 0 4.28 7 72.2 72.2 0 0 0 11.32.79A33.56 33.56 0 0 0 46.09 55 27.52 27.52 0 0 0 59 31.94C59 21 53.85 14.08 46.09 10m-1.28 39.8a18.94 18.94 0 0 1-26.12-5.62c-5.66-8.73-2.86-20 5.63-26 9.5-6.75 21.68-4.09 26.12 5.62 4.33 9.46 3.14 20.39-5.63 26"
    />
  </svg>
);

export default PaxGold;
